export function convertDate(dateString: string): string {
  const [year, month, day] = dateString.split("-");

  return `${day}/${month}/${year}`;
}

/** Takes the literal Y-M-D prefix (ignores any offset) and builds local midnight — only safe for bare date-only or "Z" values. */
export function parseISODate(value: string | null | undefined): Date | null {
  if (!value) return null;
  const [year, month, day] = value.slice(0, 10).split("-").map(Number);
  if (!year || !month || !day) return null;
  return new Date(year, month - 1, day);
}

/** Derives the calendar day from an ISO datetime's UTC parts (honors any offset, unlike parseISODate) and anchors it to local midnight. */
export function parseISODateUTC(value: string | null | undefined): Date | null {
  if (!value) return null;
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return null;
  return new Date(
    parsed.getUTCFullYear(),
    parsed.getUTCMonth(),
    parsed.getUTCDate()
  );
}

/** Formats a Date's local calendar day as YYYY-MM-DD. */
export function toISODateString(date: Date | null): string {
  if (!date) return "";
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

/** Formats a Date's local calendar day as DD/MM/YYYY. */
export function formatDate(date: Date | null | undefined): string {
  if (!date) return "";
  return convertDate(toISODateString(date));
}

/** Re-anchors a Date's local calendar day to UTC midnight — keeps a wizard-picked local-midnight date on the same day regardless of offset. */
export function toUTCMidnightISOString(date: Date | null): string | null {
  if (!date) return null;
  return `${toISODateString(date)}T00:00:00.000Z`;
}
